import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { gsap } from 'gsap';
import { HiX } from 'react-icons/hi';
import './Drawer.css';

const Drawer = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const drawerRef = React.useRef(null);
  const overlayRef = React.useRef(null);

  useEffect(() => {
    if (isOpen) {
      gsap.set([drawerRef.current, overlayRef.current], { display: 'block' });
      
      gsap.timeline()
        .fromTo(overlayRef.current, 
          { opacity: 0 }, 
          { opacity: 1, duration: 0.3 }
        )
        .fromTo(drawerRef.current, 
          { x: '-100%' }, 
          { x: '0%', duration: 0.4, ease: 'power2.out' },
          '-=0.1'
        );
    } else {
      gsap.timeline()
        .to(drawerRef.current, { 
          x: '-100%', 
          duration: 0.3, 
          ease: 'power2.in' 
        })
        .to(overlayRef.current, { 
          opacity: 0, 
          duration: 0.2,
          onComplete: () => {
            gsap.set([drawerRef.current, overlayRef.current], { display: 'none' });
          }
        }, '-=0.1');
    }
  }, [isOpen]);

  const handleNavigation = (path) => {
    navigate(path);
    onClose();
  };

  return (
    <>
      <div 
        ref={overlayRef} 
        className="drawer-overlay" 
        onClick={onClose}
        style={{ display: 'none' }}
      />
      
      <nav 
        ref={drawerRef} 
        className="drawer"
        style={{ display: 'none' }}
      >
        <button className="drawer-close" onClick={onClose}>
          <HiX size={20} />
        </button>
        
        <div className="drawer-menu">
          <button
            onClick={() => handleNavigation('/')}
            className={`menu-link ${location.pathname === '/' ? 'active' : ''}`}
          >
            PORTFOLIO
          </button>
          
          <button
            onClick={() => handleNavigation('/about')}
            className={`menu-link ${location.pathname === '/about' ? 'active' : ''}`}
          >
            ABOUT ME
          </button>
          
          <button
            onClick={() => handleNavigation('/contact')}
            className={`menu-link ${location.pathname === '/contact' ? 'active' : ''}`}
          >
            CONTACT
          </button>
        </div>
      </nav>
    </>
  );
};

export default Drawer;
